import React from 'react'
import { HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

import './error-views.less'

function ArticleContentError() {
  return (
    <div>
      <div>
        <HeadingText
          data-testid="hc-article-content-error-heading"
          size="lg"
          className="content-error__label"
        >
          <Message id="app.article.errorMessage" />
        </HeadingText>
      </div>
      <div>
        <HeadingText
          data-testid="hc-article-content-error-desc"
          size="sm"
          className="content-error__label"
        >
          <Message
            id="app.helpcenter.error.subLabel"
            link={(innerMessage) => <a href="/cshelp/home">{innerMessage}</a>}
          />
        </HeadingText>
      </div>
    </div>
  )
}

export default ArticleContentError
